<div
  class="private-listing-card small-listing-card-private"
  *ngIf="point && (force || (elementVisible$ | async))"
  [ngClass]="{
    selected: selected
  }"
>
  <div class="private-listing-image" (click)="onViewProperty()" [ngStyle]="{ 'background-image': 'url(' + photoUrl + ')' }"></div>
  <div class="private-listings-info" (click)="onViewProperty()">
    <div class="private-name-location-inner">
      <h4 class="site-name-title" [innerHTML]="name"></h4>
      <div class="location-copy" [innerHTML]="point.location"></div>
      @if (point.availableSiteCount && point.availableSiteCount > 1) {
        <div class="sites-pill">
          <span (click)="sitePrevious($event)" class="prev-pill">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </span>
          <div class="sites-pill-copy">
            {{ sitePosition + 1 }}
            of
            {{ point.availableSiteCount || 1 }}
          </div>
          <span (click)="siteNext($event)" class="next-pill">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span>
        </div>
      }
    </div>
    <div>
      <div class="location-copy private">
        @if (point.lowPrice && point.highPrice && point.lowPrice !== point.highPrice) {
          {{ point.lowPrice | currency: 'USD' : '$' : '1.0-0' }} -
          {{ point.highPrice | currency: 'USD' : '$' : '1.0-0' }}
        } @else {
          {{ point.price | currency: 'USD' : '$' : '1.0-0' }}
        }
        Per Night
      </div>
    </div>
  </div>
  <div class="private-add-fav-outer">
    <div class="favorite-outer" (click)="onFavorite($event)">
      @if (favorite) {
      <ion-icon name="heart" color="orange"></ion-icon>
      } @else {
      <ion-icon name="heart-outline" color="orange"></ion-icon>
      }
    </div>
    <div class="cnt-button trip" (click)="onAddToTrip($event)" *ngIf="!addedToTrip">
      <div class="cnt-button-icon">
        <div class="html-embed w-embed">
          <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
        </div>
      </div>
      <div class="cnt-button-copy">Add To Trip</div>
    </div>
    <div class="cnt-button trip" (click)="onRemoveFromTrip($event)" *ngIf="addedToTrip">
      <div class="cnt-button-icon">
        <div class="html-embed w-embed">
          <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
        </div>
      </div>
      <div class="cnt-button-copy">Remove From Trip</div>
    </div>
  </div>
</div>
